export interface Review {
  id: string;
  name: string;
  role: string;
  company: string;
  avatar: string;
  rating: number;
  content: string;
}

export const reviews: Review[] = [
  {
    id: 'review-1',
    name: '张明远',
    role: '技术总监',
    company: '云帆科技',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%2C%20business%20casual%2C%20warm%20friendly%20expression%2C%20clean%20neutral%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-zhang&orientation=squarish',
    rating: 5,
    content: 'mrds 是我们团队用过最优秀的专业平台。自从引入 mrds 后，我们的数据处理效率提升了至少三倍，自动化工作流功能尤其令人印象深刻，强烈推荐给所有需要数据驱动决策的团队。',
  },
  {
    id: 'review-2',
    name: '李思涵',
    role: '运营主管',
    company: '星辰互联',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%2C%20business%20attire%2C%20confident%20warm%20smile%2C%20clean%20neutral%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-li&orientation=squarish',
    rating: 5,
    content: '作为运营团队的负责人，mrds 让我的工作变得无比轻松。可视化的数据看板让我可以实时监控各项运营指标，自动化报表功能每周帮我节省了至少十个小时的工作时间。',
  },
  {
    id: 'review-3',
    name: '王浩然',
    role: '创始人兼CEO',
    company: '锐思创新',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%2C%20modern%20business%20style%2C%20confident%20expression%2C%20clean%20neutral%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-wang&orientation=squarish',
    rating: 5,
    content: '作为一个创业公司的创始人，mrds 帮助我们以极低的成本实现了企业级的数字化管理。从客户管理到数据分析，mrds 一站式满足了我们所有的需求。这是我们今年最正确的投资决策。',
  },
  {
    id: 'review-4',
    name: '陈雨桐',
    role: '数据分析师',
    company: '数联科技',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%2C%20smart%20casual%20style%2C%20friendly%20professional%20smile%2C%20clean%20neutral%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-chen&orientation=squarish',
    rating: 4,
    content: 'mrds 的数据可视化功能非常强大，图表类型丰富，交互体验流畅。内置的智能分析算法也很有用，帮助我发现了不少之前被忽视的数据洞察。唯一希望的是移动端体验可以进一步优化。',
  },
  {
    id: 'review-5',
    name: '刘建国',
    role: 'IT经理',
    company: '恒通集团',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%2C%20business%20formal%2C%20experienced%20professional%20look%2C%20clean%20neutral%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-liu&orientation=squarish',
    rating: 5,
    content: '从IT管理的角度来看，mrds 的安全管控机制让人非常放心。细粒度的权限管理和完整的审计日志，让我们能够放心地将核心业务数据托管在 mrds 平台上。部署和维护也非常简便。',
  },
  {
    id: 'review-6',
    name: '赵雪莹',
    role: '市场总监',
    company: '博雅营销',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%2C%20creative%20business%20style%2C%20bright%20friendly%20smile%2C%20clean%20neutral%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-zhao&orientation=squarish',
    rating: 5,
    content: 'mrds 帮助我们市场团队实现了营销数据的全链路追踪和分析。从广告投放到转化漏斗，每一个环节的数据都清晰可见。现在我们可以基于真实数据做决策，而不是凭感觉。团队整体效率提升了至少50%。',
  },
];

export const stats = [
  { value: '50,000+', label: '活跃用户', icon: 'ri-user-star-line' },
  { value: '99.9%', label: '服务可用率', icon: 'ri-shield-check-line' },
  { value: '120+', label: '国家与地区覆盖', icon: 'ri-global-line' },
  { value: '10,000+', label: '企业客户', icon: 'ri-building-line' },
];